<template>
    <table class="min-w-full divide-y divide-gray-300 mt-8 print:mt-0">
        <thead>
            <tr>
                <th
                    scope="col"
                    class="py-3 pl-4 pr-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500 sm:pl-0"
                >
                    {{ $t('name-short') }}
                </th>
                <th scope="col" class="px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500">
                    {{ $t('name-long') }}
                </th>
                <th
                    scope="col"
                    class="px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500 font-mono text-[0.85rem]"
                >
                    {{ $t('external-id') }}
                </th>
                <th
                    scope="col"
                    class="px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500 tabular-nums"
                >
                    {{ $t('cad-gross-space') }}
                </th>
                <th scope="col" class="px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500">
                    {{ $t('cleaning-gross-space') }}
                </th>
                <th scope="col" class="px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500">
                    {{ $t('sbv-gross-space') }}
                </th>
            </tr>
        </thead>
        <tbody class="divide-y divide-gray-200 bg-white">
            <template v-for="space in spaces" v-if="spaces && spaces.length" :key="space.id">
                <tr class="bg-gray-50 hover:bg-sky-200 divide-x divide-gray-200">
                    <td
                        class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-semibold text-gray-900 sm:pl-0 hover:underline"
                    >
                        <router-link :to="routeForLocation(space.__typename, space.id)" class="block" target="_blank">
                            {{ space.nameShort }}
                        </router-link>
                    </td>
                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                        {{ space.nameLong }}
                    </td>
                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 font-mono text-[0.85rem]">
                        {{ space.extId }}
                    </td>
                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-right tabular-nums">
                        {{ getTVValue(space.cadGrossSpace) }}
                    </td>
                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-right tabular-nums">
                        {{ getTVValue(space.cleaningGrossSpace) }}
                    </td>
                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-right tabular-nums">
                        {{ getTVValue(space.sbvGrossSpace) }}
                    </td>
                </tr>
                <tr
                    v-for="subspace in space.subspaces.nodes"
                    :key="subspace.id"
                    class="bg-white hover:bg-sky-100 divide-x divide-gray-200"
                >
                    <td class="whitespace-nowrap py-2 pl-8 pr-3 text-sm font-normal text-gray-900 sm:pl-3">
                        <div class="flex flex-col">
                            <router-link
                                :to="routeForLocation(subspace.__typename, subspace.id)"
                                class="hover:underline"
                                target="_blank"
                            >
                                {{ subspace.nameShort }}
                            </router-link>
                            <div class="text-gray-500">{{ subspace.type?.name }}</div>
                        </div>
                    </td>
                    <td class="whitespace-nowrap px-3 py-2 text-sm text-gray-500">
                        {{ subspace.nameLong }}
                    </td>
                    <td class="whitespace-nowrap px-3 py-2 text-sm text-gray-500 font-mono text-[0.85rem]">
                        {{ subspace.extId }}
                    </td>
                    <td class="whitespace-nowrap px-3 py-2 text-sm text-gray-500 text-right tabular-nums">
                        {{ getTVValue(subspace.cadGrossSpace) }}
                    </td>
                    <td class="whitespace-nowrap px-3 py-2 text-sm text-gray-500 text-right tabular-nums">
                        {{ getTVValue(subspace.cleaningGrossSpace) }}
                    </td>
                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-right tabular-nums">
                        {{ getTVValue(subspace.sbvGrossSpace) }}
                    </td>
                </tr>
            </template>
            <tr v-else>
                <td colspan="6">
                    <Message class="text-gray-500" :headline="$t('no-spaces-for-type-headline')" status="info">
                        {{ emptyListInfoMessage }}
                    </Message>
                </td>
            </tr>
        </tbody>
    </table>
</template>
<script setup lang="ts">
import Message from '@/components/Message/Message.vue';
import { routeForLocation } from '@/location/location';
import { SpaceItem } from '../types';
import { getTVValue } from '../utils';

defineProps<{ spaces: SpaceItem[]; emptyListInfoMessage: string }>();
</script>
